document.addEventListener("DOMContentLoaded", function() {
    const addToCartButton = document.querySelector(".product-form__submit"),
        stickyContainer = document.querySelector(".sticky_add_to_cart_container"),
        observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: .5
        },
        handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                entry.isIntersecting ? stickyContainer.classList.remove("sticky_handle") : entry.boundingClientRect.top < 0 ? stickyContainer.classList.add("sticky_handle") : stickyContainer.classList.remove("sticky_handle")
            })
        };
    /* Fichas sin el boton de Dawn (ACV, vinagre...): no hay nada que observar.
       Antes daba un error de JavaScript en cada carga. */
    if (!addToCartButton || !stickyContainer) return;
    new IntersectionObserver(handleIntersection, observerOptions).observe(addToCartButton);
    let mainAtc = document.querySelector(".product-form__submit"),
        stickyAtc = document.querySelector(".sticky_add_to_btn"),
        stickyAtcText = stickyAtc.innerHTML;
    stickyAtc.addEventListener("click", function() {
        mainAtc.click(), stickyAtc.innerHTML = "...", setTimeout(function() {
            stickyAtc.innerHTML = stickyAtcText
        }, 500)
    });
    const productItems = document.querySelectorAll(".ProductForm__Item"),
        stickyCartPrice = document.querySelector(".sticky_price"),
        handleMutation = (mutationsList, observer) => {
            mutationsList.forEach(mutation => {
                mutation.type === "attributes" && mutation.attributeName === "aria-expanded" && changeStickyPrice()
            })
        },
        mutationObserver = new MutationObserver(handleMutation);
    productItems.forEach(productItem => {
        mutationObserver.observe(productItem, {
            attributes: !0
        })
    });

    function changeStickyPrice() {
        const productPrice = document.querySelector(".ProductMeta__Price").innerHTML;
        stickyCartPrice.innerHTML = productPrice
    }
});
